import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const fiscalCodeValidate = http.post<
  object,
  membershipApi.ValidateFiscalCodeRequest,
  membershipApi.ValidateFiscalCodeResponse
>(apiBaseUrl + '/fiscalCode/validate', async ({ request }) => {
  const body = await request.json()
  return HttpResponse.json({
    isValid: body.fiscalCode?.length === 16,
    birthDate: body.fiscalCode?.[0] === 'P' ? '1970-10-10' : '2020-10-10',
    idAdult: body.fiscalCode?.[0] === 'P',
  })
})
